<i18n>
{
	"en": {
		"title": "Logged in as",
		"logOut": "Log out"
	},
	"no": {
		"title": "Logget inn som",
		"logOut": "Logg ut"
	}
}
</i18n>

<template>
	<t-dialog
		:isShown="isShown"
		width="280px"
		:title="$t('title')"
		:confirmLabel="$t('logOut')"
		centerDefaultButtonsVertically
		@ok="logout"
		@close="$emit('close')"
	>
		<div class="content">
			<t-timpex-icon
				icon="user"
				type="bp"
				size="large"
				style="margin-top: 24px"
			/>
			<div style="margin: 10px 0 20px 0">{{ currentUser.displayName }}</div>
		</div>
	</t-dialog>
</template>

<script>
import { userAuth } from '@/core';
import { mapState, mapActions } from 'vuex';
import TDialog from '@/components/evergreen/overlays/TDialog';

export default {
	name: 'Logout',
	components: { TDialog },
	props: { isShown: Boolean, },
	data() {
		return {};
	},
	computed: {
		...mapState('login', ['currentUser']),
		photoUrl() {
			return this.currentUser.photoUrl;
		}
	},
	methods: {
		...mapActions('login', ['clearUserStore']),
		logout() {
			userAuth.signOut();
			this.$emit('close');
			this.clearUserStore();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@/components/evergreen/scss/colors";

.content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

</style>

